import {useBaseApi} from "../useBaseApi";
import {StatusCodes} from "http-status-codes";

export function useAclRepository() {
    const {post} = useBaseApi();

    const validateAcl = async (body) => {
        let response = await post("/acl/validate", body, false);

        if(response.status === StatusCodes.OK){
            return true;
        }

        return false;
    }

    return {validateAcl};
}
